import {Component, OnInit, Input} from '@angular/core';
import {RouteService} from '../../shared/services/route.service';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {RouteGroup} from '../../shared/models/routeGroup.model';

const now = new Date();

@Component({
    selector: 'form-edit-route-group',
    templateUrl: 'form-edit-route-group.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormEditRouteGroupComponent implements OnInit {
    constructor(
        private routeService: RouteService,
        private dataStorageService: DataStorageService) {
    }

    @Input() routeGroup: RouteGroup;
    routeGroupForm: FormGroup;

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.routeGroupForm = new FormGroup({
            'calendar_group': new FormControl(this.routeGroup.calendar_group),
            'dispatch_group_id': new FormControl(this.routeGroup.dispatch_group_id),
            'title': new FormControl(this.routeGroup.title),
            'acct': new FormControl(this.routeGroup.acct)
        });
    }


    onEditRoute() {
        const value = this.routeGroupForm.value;
        const newRouteGroup = new RouteGroup(
            this.routeGroup.id, value.title, value.acct, value.calendar_group, value.dispatch_group_id, this.routeGroup.created);
        this.dataStorageService.updateRouteGroup(newRouteGroup);
    }

}
